import React, { forwardRef, ReactNode } from 'react'
import { isDesktop, isTablet } from 'react-device-detect'
import { Helmet } from 'react-helmet'
import Loader from '../Loader/Loader'

interface MemberFormPageLayoutProps {
  title: string
  isReady: boolean
  children: ReactNode
}

export const MemberFormPageLayout = forwardRef<
  HTMLElement,
  MemberFormPageLayoutProps
>(({ title, isReady, children }, ref) => (
  <>
    <Helmet>
      <title>{`Time Off - ${title}`}</title>
    </Helmet>
    <main ref={ref} className="container-fluid scrollable">
      <div className={`row pt-3 ${isDesktop || isTablet ? 'h-100' : ''}`}>
        <div className="col-12 employee-form-page d-flex flex-column align-items-center justify-content-center bg-lazuli-white pb-5">
          <h1 className="align-self-start employee-form-title">{title}</h1>
          {isReady ? children : <Loader />}
        </div>
      </div>
    </main>
  </>
))

MemberFormPageLayout.displayName = 'MemberFormPageLayout'
